import { cn } from '@/lib/utils'

export interface StockIndicatorProps {
  stock: number
  capacity: number
}

function getStockColor(stock: number): string {
  if (stock === 0) return 'text-destructive'
  if (stock === 1) return 'text-warning'
  return 'text-success'
}

export function StockIndicator({ stock, capacity }: StockIndicatorProps): React.ReactElement {
  return (
    <p className={cn('text-sm', getStockColor(stock))}>
      <span className="font-semibold">{stock}</span>
      <span> / {capacity}</span>
    </p>
  )
}
